import { ACTIONS } from '../Constants';

const initialState = {
    byId: {}
};

const abilities = (state = initialState, action) => {
    let newById;
    let reduced;
    let ability;

    switch (action.type) {
        case ACTIONS.GET_MANY_ABILITIES: {
            const { abilities = [] } = action.payload;

            reduced = abilities.reduce((prev, ability) => {
                prev[ability._id] = ability;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_ABILITY:
        case ACTIONS.PUT_ABILITY_SUCCESS:
        case ACTIONS.POST_ABILITY_SUCCESS: {
            ({ ability } = action.payload);
            newById = {
                ...state.byId,
                [ability._id]: ability
            };
            return {
                ...state,
                byId: newById
            };
        }

        default:
            return state;
    }
};

export default abilities;
